import { useEffect } from "react";

import { HeaderWithNextButtonLayout } from "@components";
import {
  AdditionalProfessionalQualifications,
  Educations,
  ForeignTrainings,
  Honours,
  LocalTrainings,
  Publications,
} from "./components";

import { useQualifications } from "@hooks/HRM/employee/useQualifications";

export interface QualificationInfoPropsType {
  id: number | null;
  changeActiveTab: (arg: number) => void;
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
  isProfileDisabled: boolean;
}

function Qualification({
  id,
  changeActiveTab,
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
  isProfileDisabled,
}: QualificationInfoPropsType) {
  const {
    qualificationInfo,

    changeEducationsInfo,
    changeLocalTrainingsInfo,
    changeForeignTrainingsInfo,
    changeAdditionalProfessionalQualificationsInfo,
    changePublicationsInfo,
    changeHonoursInfo,

    removeEducationInfo,
    removeLocalTrainingInfo,
    removeForeignTrainingInfo,
    removeAdditionalProfessionalQualificationInfo,
    removePublicationInfo,
    removeHonourInfo,

    getQualificationInfoRequestOngoing,

    updateEducationRequestOngoing,
    updateEducationSuccess,
    updateEducationFailed,

    updateLocalTrainingRequestOngoing,
    updateLocalTrainingSuccess,
    updateLocalTrainingFailed,

    updateForeignTrainingRequestOngoing,
    updateForeignTrainingSuccess,
    updateForeignTrainingFailed,

    updateAdditionalProfessionalQualificationRequestOngoing,
    updateAdditionalProfessionalQualificationSuccess,
    updateAdditionalProfessionalQualificationFailed,

    updatePublicationRequestOngoing,
    updatePublicationSuccess,
    updatePublicationFailed,

    updateHonourRequestOngoing,
    updateHonourSuccess,
    updateHonourFailed,

    updateRewardSuccess,
    updateRewardFailed,

    deleteEducationRequestOngoing,
    deleteEducationSuccess,
    deleteEducationFailed,

    deleteLocalTrainingRequestOngoing,
    deleteLocalTrainingSuccess,
    deleteLocalTrainingFailed,

    deleteForeignTrainingRequestOngoing,
    deleteForeignTrainingSuccess,
    deleteForeignTrainingFailed,

    deleteAdditionalProfessionalQualificationRequestOngoing,
    deleteAdditionalProfessionalQualificationSuccess,
    deleteAdditionalProfessionalQualificationFailed,

    deletePublicationRequestOngoing,
    deletePublicationSuccess,
    deletePublicationFailed,

    deleteHonourRequestOngoing,
    deleteHonourSuccess,
    deleteHonourFailed,
  } = useQualifications(id);

  const {
    educations,
    localTrainings,
    foreignTrainings,
    additionalProfessionalQualifications,
    publications,
    honours,
  } = qualificationInfo || {};

  useEffect(() => {
    setIsSuccessModalOpen(
      updateEducationSuccess ||
        updateLocalTrainingSuccess ||
        updateForeignTrainingSuccess ||
        updateAdditionalProfessionalQualificationSuccess ||
        updatePublicationSuccess ||
        updateHonourSuccess ||
        updateRewardSuccess ||
        deleteEducationSuccess ||
        deleteLocalTrainingSuccess ||
        deleteForeignTrainingSuccess ||
        deleteAdditionalProfessionalQualificationSuccess ||
        deletePublicationSuccess ||
        deleteHonourSuccess,
    );
    setIsErrorModalOpen(
      updateEducationFailed ||
        updateLocalTrainingFailed ||
        updateForeignTrainingFailed ||
        updateAdditionalProfessionalQualificationFailed ||
        updatePublicationFailed ||
        updateHonourFailed ||
        updateRewardFailed ||
        deleteEducationFailed ||
        deleteLocalTrainingFailed ||
        deleteForeignTrainingFailed ||
        deleteAdditionalProfessionalQualificationFailed ||
        deletePublicationFailed ||
        deleteHonourFailed,
    );
  }, [
    updateEducationSuccess,
    updateLocalTrainingSuccess,
    updateForeignTrainingSuccess,
    updateAdditionalProfessionalQualificationSuccess,
    updatePublicationSuccess,
    updateHonourSuccess,
    updateRewardSuccess,
    deleteEducationSuccess,
    deleteLocalTrainingSuccess,
    deleteForeignTrainingSuccess,
    deleteAdditionalProfessionalQualificationSuccess,
    deletePublicationSuccess,
    deleteHonourSuccess,
    updateEducationFailed,
    updateLocalTrainingFailed,
    updateForeignTrainingFailed,
    updateAdditionalProfessionalQualificationFailed,
    updatePublicationFailed,
    updateHonourFailed,
    updateRewardFailed,
    deleteEducationFailed,
    deleteLocalTrainingFailed,
    deleteForeignTrainingFailed,
    deleteAdditionalProfessionalQualificationFailed,
    deletePublicationFailed,
    deleteHonourFailed,
  ]);

  return (
    <HeaderWithNextButtonLayout
      title="EMPLOYEE.QUALIFICATION_INFO.HEADING"
      subtitle="EMPLOYEE.QUALIFICATION_INFO.DESCRIPTION"
      action={() => changeActiveTab(4)}
    >
      <div className="d-flex flex-column gap-10">
        <Educations
          educationsInfo={educations}
          changeEducationsInfo={changeEducationsInfo}
          removeEducationInfo={removeEducationInfo}
          getQualificationInfoRequestOngoing={
            getQualificationInfoRequestOngoing
          }
          updateEducationRequestOngoing={updateEducationRequestOngoing}
          deleteEducationRequestOngoing={deleteEducationRequestOngoing}
          isProfileDisabled={isProfileDisabled}
        />
        <LocalTrainings
          localTrainingsInfo={localTrainings}
          changeLocalTrainingsInfo={changeLocalTrainingsInfo}
          removeLocalTrainingInfo={removeLocalTrainingInfo}
          getQualificationInfoRequestOngoing={
            getQualificationInfoRequestOngoing
          }
          updateLocalTrainingRequestOngoing={updateLocalTrainingRequestOngoing}
          deleteLocalTrainingRequestOngoing={deleteLocalTrainingRequestOngoing}
          isProfileDisabled={isProfileDisabled}
        />
        <ForeignTrainings
          foreignTrainingsInfo={foreignTrainings}
          changeForeignTrainingsInfo={changeForeignTrainingsInfo}
          removeForeignTrainingInfo={removeForeignTrainingInfo}
          getQualificationInfoRequestOngoing={
            getQualificationInfoRequestOngoing
          }
          updateForeignTrainingRequestOngoing={
            updateForeignTrainingRequestOngoing
          }
          deleteForeignTrainingRequestOngoing={
            deleteForeignTrainingRequestOngoing
          }
          isProfileDisabled={isProfileDisabled}
        />
        <AdditionalProfessionalQualifications
          additionalProfessionalQualificationsInfo={
            additionalProfessionalQualifications
          }
          changeAdditionalProfessionalQualificationsInfo={
            changeAdditionalProfessionalQualificationsInfo
          }
          removeAdditionalProfessionalQualificationInfo={
            removeAdditionalProfessionalQualificationInfo
          }
          getQualificationInfoRequestOngoing={
            getQualificationInfoRequestOngoing
          }
          updateAdditionalProfessionalQualificationRequestOngoing={
            updateAdditionalProfessionalQualificationRequestOngoing
          }
          deleteAdditionalProfessionalQualificationRequestOngoing={
            deleteAdditionalProfessionalQualificationRequestOngoing
          }
          isProfileDisabled={isProfileDisabled}
        />
        <Publications
          publicationsInfo={publications}
          changePublicationsInfo={changePublicationsInfo}
          removePublicationInfo={removePublicationInfo}
          getQualificationInfoRequestOngoing={
            getQualificationInfoRequestOngoing
          }
          updatePublicationRequestOngoing={updatePublicationRequestOngoing}
          deletePublicationRequestOngoing={deletePublicationRequestOngoing}
          isProfileDisabled={isProfileDisabled}
        />
        <Honours
          honoursInfo={honours}
          changeHonoursInfo={changeHonoursInfo}
          removeHonourInfo={removeHonourInfo}
          getQualificationInfoRequestOngoing={
            getQualificationInfoRequestOngoing
          }
          updateHonourRequestOngoing={updateHonourRequestOngoing}
          deleteHonourRequestOngoing={deleteHonourRequestOngoing}
          isProfileDisabled={isProfileDisabled}
        />
      </div>
    </HeaderWithNextButtonLayout>
  );
}

export default Qualification;
